import State from '../core/State';
import { OrganizationDetailFragment } from '../generated/graphql';

export const startFetchingOrganizations = () => (state: State): State => ({
  ...state,
  availableOrganizations: {
    ...state.availableOrganizations,
    fetching: state.availableOrganizations.fetching + 1,
  },
});

export const finishFetchingOrganizations = (organizations: Array<OrganizationDetailFragment>) => (
  state: State,
): State => ({
  ...state,
  availableOrganizations: {
    items: organizations,
    fetching: state.availableOrganizations.fetching - 1,
  },
});
